import { render, staticRenderFns } from "./Pagination.vue?vue&type=template&id=2e9bc011"
import script from "./pagination.ts?vue&type=script&lang=ts&external"
export * from "./pagination.ts?vue&type=script&lang=ts&external"
import style0 from "./pagination.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports